import { IDropDownOptions } from "../../Components/FormValidationInputs/AppSelectList";

export const usersList: IDropDownOptions[] = [
    { value: 'User', id: 1 },
    { value: 'Sub-Admin', id: 2 },
    { value: 'Admin', id: 3 },
    { value: 'Client', id: 4 },
    { value: 'VA User', id: 5 },
    { value: 'Api User', id: 6 },
    { value: 'Internal Auditor', id: 10 },
    { value: 'Scorecard Admin', id : 11 },
    { value: 'Client Admin', id : 12 }
]

export enum BEE123UserTypes {
    User = 1,
    SubAdmin = 2,
    Admin = 3,
    Client = 4,
    VAUser = 5,
    APIUser = 6,
    SupplierManagementUser = 7,
    SupportUser = 8,
    SiteAdministration = 9,
    InternalAuditor = 10,
    ScorecardAdmin = 11,
    ClientAdmin = 12,
    Analyst = 13,
    TechnicalSignatory = 14
}